import React from 'react';

import { useAppSelector } from '@/store';
import { useUserList } from '@/components/pages/Users/Index/hooks/useUserList';

import { UserList } from '../Presentaition';
import { authStore } from '@/store/auth';

export type FormValues = {
  lastName: string;
  firstName: string;
  kanaLastName: string;
  kanaFirstName: string;
  email: string;
  nameId?: string;
};

export const UserListContainer: React.FC = () => {
  const currentOrganization = useAppSelector(
    authStore.selectors.organizationSelector,
  );

  const {
    bulkUpdate,
    cancelPreview,
    csvFormatError,
    csvUpdateErrors,
    hasUpdateError,
    isLoading,
    isPreview,
    isUpdating,
    isUploading,
    onCancelClick,
    onDownloadCsvClick,
    onEditLinkClick,
    onUploadCsvClick,
    selectedUserId,
    showUserForm,
    updateUser,
    users,
  } = useUserList(currentOrganization);

  return (
    <UserList
      bulkUpdate={bulkUpdate}
      cancelPreview={cancelPreview}
      csvFormatError={csvFormatError}
      csvUpdateErrors={csvUpdateErrors}
      hasUpdateError={hasUpdateError}
      isLoading={isLoading}
      isPreview={isPreview}
      isUpdating={isUpdating}
      isUploading={isUploading}
      onCancelClick={onCancelClick}
      onDownloadCsvClick={onDownloadCsvClick}
      onEditLinkClick={onEditLinkClick}
      onUpdateUser={updateUser}
      onUploadCsvClick={onUploadCsvClick}
      selectedUserId={selectedUserId}
      showUserForm={showUserForm}
      users={users}
    />
  );
};
